import React from 'react';
import { TreeItem } from '@mui/lab'; // Ensure to import TreeItem from the correct library
import ListItem from '@mui/material/ListItem';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import muiStyles from './muiStyles';
import { useTranslation } from 'react-i18next'; // Import translation hook if using i18next
import NavLinkMui from './NavLinkMui'; // Ensure to import your NavLinkMui
import DynamicIcon from '../util/DynamicIcon';
import useGlobal from '../util/Global';
import { ListItemIcon, ListItemText } from '@mui/material';


const TreeNav = ({ item, parentPath, handleSelect, exact = false, className, children }) => {
    const classes = muiStyles();

    const { t } = useGlobal();
    return (
        <TreeItem
            aria-label="group item"
            key={item.path || item.title}
            nodeId={item.path || item.title}
            sx={{
                padding: "0px",
                margin: "0px",
                // Ensure the item is displayed correctly
                '& .MuiTreeItem-label': {
                    display: 'flex',
                    paddingLeft: "0px",
                    marginLeft: "-12px",

                    alignItems: 'left',
                    justifyContent: 'space-between', // Space out the items
                },
            }}
            label={
                item.path ? (
                    <NavLinkMui
                        to={item.path}
                        end={exact}
                        onClick={(event) => handleSelect(event, item.path, parentPath)}
                        className={className}
                    >
                        <ListItemIcon>
                            {item.iconPath ? <DynamicIcon iconName={item.iconPath} /> : <MoreHorizIcon />}
                        </ListItemIcon>
                        <span className={classes.groupItem}>
                            {item?.useGlobal === true ? t(item.title) : item.title}
                        </span>
                    </NavLinkMui>
                ) : (
                    <ListItem
                        button
                        onClick={(event) => handleSelect(event, item.title, parentPath)}
                        className={className}
                    >
                        <ListItemIcon>
                            {item.iconPath ? <DynamicIcon iconName={item.iconPath} /> : <MoreHorizIcon />}
                        </ListItemIcon>
                        <span className={classes.groupItem}>
                            {item?.useGlobal === true ? t(item.title) : item.title}
                        </span>
                    </ListItem>
                )
            }
        >
            {children}
        </TreeItem>
    );
};

export default TreeNav;
